import React, { FC } from 'react';
import { Container } from 'react-bootstrap';
import BaseTemplate from '../BaseTemplate';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';
import LandscapeProjectsEditProjectsImpactTemplate from '../../../templates/LandscapeProjectsEditProjectsImpactTemplate';
import styles from './LandscapeProjectsAddProjectsImpactIndicatorsTemplate.module.css';
import cn from 'classnames';
import { Button } from '../../atoms';
import {
  IndicatorModal,
  LandscapeProjectsAddProjectsImpactIndicatorsOrganism,
} from '../../organisms';
import { LandscapeIndicatorDetailsResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-indicator-details-response.dto';
import { TableItem } from '../../organisms/LandscapeProjectsAddProjectsImpactIndicatorsOrganism/LandscapeProjectsAddProjectsImpactIndicatorsOrganism';

interface LandscapeProjectsAddProjectsImpactIndicatorsTemplateProps {
  show: boolean;
  setShow: (show: boolean) => void;
  indicators: LandscapeIndicatorDetailsResponseDto[];
  handleSubmit: () => void;
  handleDelete: (id: string) => void;
  setSelectedIndicator: React.Dispatch<
    React.SetStateAction<LandscapeIndicatorDetailsResponseDto | undefined>
  >;
  tableItems: TableItem[];
  setTableItems: (items: TableItem[], from: number, to: number) => void;
  changeOrderEnabled: boolean;
  setChangeOrderEnabled: (enabled: boolean) => void;
}

const LandscapeProjectsAddProjectsImpactIndicatorsTemplate: FC<
  LandscapeProjectsAddProjectsImpactIndicatorsTemplateProps
> = ({
  show,
  setShow,
  indicators,
  handleSubmit,
  handleDelete,
  setSelectedIndicator,
  tableItems,
  setTableItems,
  changeOrderEnabled,
  setChangeOrderEnabled,
}) => {
  return (
    <>
      <BaseTemplate>
        <Container>
          <LandscapeEditProjectsAddProjectTemplate>
            <LandscapeProjectsEditProjectsImpactTemplate>
              <div className={cn(styles.landscapeAboutContactPersonsWrapper)}>
                <div className={cn(styles.button)}>
                  <Button variant="dark" onClick={() => setShow(true)}>
                    Add Indicator
                  </Button>
                  <Button
                    variant="dark"
                    onClick={() => setChangeOrderEnabled(!changeOrderEnabled)}
                  >
                    Change Order
                  </Button>
                </div>
                <div className={cn(styles.tableWrapper)}>
                  <LandscapeProjectsAddProjectsImpactIndicatorsOrganism
                    handleDelete={handleDelete}
                    tableItems={tableItems}
                    setTableItems={setTableItems}
                    changeOrderEnabled={changeOrderEnabled}
                  />
                </div>
              </div>
            </LandscapeProjectsEditProjectsImpactTemplate>
          </LandscapeEditProjectsAddProjectTemplate>
        </Container>

        {show && (
          <IndicatorModal
            show={show}
            setShow={setShow}
            indicators={indicators}
            handleSubmit={handleSubmit}
            setSelectedIndicator={setSelectedIndicator}
          />
        )}
      </BaseTemplate>
    </>
  );
};

export default LandscapeProjectsAddProjectsImpactIndicatorsTemplate;
